/**
 * /dashboard/leave/approvals — Leave → Manager / HR approvals queue
 * (SOP §1.2; Phase 3b — 2026-06-01).
 *
 * Direct / deep-link route. The canonical discovery surface is the
 * unified /dashboard/approvals?tab=leave page (reachable from the Time
 * & Leave strip's "Approvals" entry); this route is preserved as a
 * stable URL for managers who bookmarked it.
 *
 * Backend RBAC is the boundary — useLeaveRoles only hides the link in
 * the module nav for non-approvers; this page itself defers to the
 * server, which scopes the list query by role (manager = own +
 * reports; hr_admin = tenant; plain employee = nothing useful).
 *
 * Migration note: port of
 * frontend/src/app/(dashboard)/dashboard/leave/approvals/page.tsx.
 * "use client" dropped; the body is the existing LeaveApprovalsTab.
 */

import { createFileRoute } from "@tanstack/react-router";
import { TimeAndLeaveShell } from "@/components/shared/time-and-leave-shell";
import { LeaveFeatureGate } from "@/components/leave/leave-feature-gate";
import { LeaveApprovalsTab } from "@/components/leave/leave-approvals-tab";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/leave/approvals",
)({
  component: LeaveApprovalsRoute,
});

function LeaveApprovalsRoute() {
  return (
    <TimeAndLeaveShell
      title="Leave approvals"
      description="Requests awaiting your sign-off."
    >
      <LeaveFeatureGate>
        <LeaveApprovalsTab />
      </LeaveFeatureGate>
    </TimeAndLeaveShell>
  );
}
